import { Controller } from "@hotwired/stimulus"

// 入力に応じて Turbo Frame の src を書き換えてリアルタイム検索する
export default class extends Controller {
  static targets = ["input"]
  static values = {
    url: String,
    frame: String,
    delay: { type: Number, default: 300 }
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      const url = new URL(this.urlValue, window.location.origin)
      const query = this.inputTarget.value.trim()
      if (query) {
        url.searchParams.set("q", query)
      }
      const frame = document.getElementById(this.frameValue)
      if (frame) {
        frame.src = url.toString()
      }
    }, this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
